
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import UAEMapSection from './components/UAEMapSection';
import ContactSection from './components/ContactSection';
import SupplierSection from './components/SupplierSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ProductsSection />
        <UAEMapSection />
        <ContactSection />
        <SupplierSection />
      </main>
      <Footer />
    </div>
  );
}
